import { render } from "./EditOverlay.vue?vue&type=template&id=712f97cc"
import script from "./EditOverlay.vue?vue&type=script&lang=js"
export * from "./EditOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__